export function OutlineTaskListIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 18.9984C5 20.1024 5.8928 21 6.992 21H17.0096C18.1088 21 19.0016 20.1024 19.0016 18.9984L18.9824 4.9872C18.9776 3.888 18.0848 3 16.9904 3H6.9968C5.8928 3 5 3.8928 5 4.9968V18.9984Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M14 7.00285L15.9536 6.99805"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 12H15.9536"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 17.002H15.9536"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.30084L8.7584 8.01604C9.1808 7.59364 10.4 6.39844 10.4 6.39844"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 11.8848L8.7584 12.6C9.1808 12.1776 10.4 10.9824 10.4 10.9824"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 16.8868L8.7584 17.602C9.1808 17.1796 10.4 15.9844 10.4 15.9844"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
